import React from "react";
import { Spinner } from "react-bootstrap";
import "../css/FullScreenSpinner.css";

const FullScreenSpinner = ({ isSendingMessage, uploadPercentage }) => {
  if (isSendingMessage) {
    return (
      <div className="fullScreenSpinner">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="progrssPercentage">
          {uploadPercentage}%
        </div>
      </div>
    );
  }
  return null;
};

export default FullScreenSpinner;
